<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="姓名:"
                      prop="person_name">
          <el-input v-model.trim="searchForm.person_name"
                    placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="类别:"
                      prop="dorm_log_type">
          <el-select v-model="searchForm.dorm_log_type"
                     placeholder="类别">
            <el-option v-for="(item, index) in typeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/dorm_log/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <el-button v-has="'/dorm_log/batch_del'"
                 type="primary"
                 @click="multipleDelete">批量删除</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button v-has="'/dorm_log/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/dorm_log/batch_del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-check v-if="showCheckModal"
               :isShow="showCheckModal"
               :data="checkData"
               @handleClose="closeCheckModal"></add-check>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddCheck from '@/views/business/dormitoryLog/AddCheck'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddCheck, Pagination },
  data() {
    return {
      typeList: [],
      searchForm: {
        person_name: '',
        dorm_log_type: ''
      },
      tableTitle: [
        {
          prop: 'dorm_log_type',
          name: '类别',
          width: '80'
        },
        {
          prop: 'person_name',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'room_name',
          name: '房间',
          width: '100'
        },
        {
          prop: 'timestamp',
          name: '时间',
          width: '120'
        },
        {
          prop: 'remarks',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加人员相关
      showCheckModal: false,
      checkData: {
        type: 'add'
      },
      // 人员授权相关
      showAuthModal: false,
      authData: {
        id: -1
      }
    }
  },
  created() {
    this.getList()
    this.getItemList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getDormLogList({
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = data.count
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取介质类型
    getItemList() {
      fetch.getItemList({ type_code: 'dorm_log_type' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加人员
    handleAdd() {
      this.showCheckModal = true
      this.checkData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delDormLog(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择日志后重试')
      }
    },
    // 编辑
    handleEdit(data) {
      this.showCheckModal = true
      this.checkData = {
        type: 'edit',
        id: data.id
      }
    },
    closeCheckModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showCheckModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delDormLog(data.id)
        })
        .catch(() => {})
    },
    delDormLog(ids) {
      fetch.batchDelDormLog({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style></style>
